import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IPrepaidProgramFormMeta {
  idBank: FormInputMeta,
  nameBank: FormInputMeta,
  idItem: FormInputMeta,
  nameItem: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  target: FormInputMeta,
  category: FormInputMeta,
  // Program parameters
  initialAmount: FormInputMeta,
  recordedFees: FormInputMeta,
  initialFees: FormInputMeta,
  // Recharge parameters
  accountMaxLimit: FormInputMeta,
  rechargeMinValue: FormInputMeta,
  rechargeMaxValue: FormInputMeta,
  rechargeFees: FormInputMeta,
  // Schema
  schema: any,
}

const PrepaidProgramFormMeta = {} as IPrepaidProgramFormMeta;

PrepaidProgramFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrepaidProgramFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Raison sociale',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.idItem = {
  name: 'idItem',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.nameItem = {
  name: 'nameItem',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.startDate = {
  name: 'startDate',
  type: 'date',
  label: 'Date debut',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.endDate = {
  name: 'endDate',
  type: 'date',
  label: 'Date d\'expiration',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.target = {
  name: 'target',
  type: 'select',
  label: 'Cible',
  placeholder: '',
  options:  [
    {
      label: 'Cible A',
      value: 'a'
    },
    {
      label: 'Cible B',
      value: 'b',
    },
    {
      label: 'Cible C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.category = {
  name: 'category',
  type: 'select',
  label: 'Catégorie',
  placeholder: '',
  options:  [
    {
      label: 'Catégorie A',
      value: 'a'
    },
    {
      label: 'Catégorie B',
      value: 'b',
    },
    {
      label: 'Catégorie C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};

// Program parameters
PrepaidProgramFormMeta.initialAmount = {
  name: 'initialAmount',
  type: 'number',
  label: 'Montant initial',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.recordedFees = {
  name: 'recordedFees',
  type: 'number',
  label: 'Frais relevés',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrepaidProgramFormMeta.initialFees = {
  name: 'initialFees',
  type: 'select',
  label: 'Frais initiaux',
  placeholder: '',
  options:  [
    {
      label: 'Currency A',
      value: 'a'
    },
    {
      label: 'Currency B',
      value: 'b',
    },
    {
      label: 'Currency C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};

// Recharge parameters
PrepaidProgramFormMeta.accountMaxLimit = {
  name: 'accountMaxLimit',
  type: 'number',
  label: 'Limite Max. Compte',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.rechargeMinValue = {
  name: 'rechargeMinValue',
  type: 'number',
  label: 'Valeur Min. Recharge',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrepaidProgramFormMeta.rechargeMaxValue = {
  name: 'rechargeMaxValue',
  type: 'number',
  label: 'Valeur Max. Recharge',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrepaidProgramFormMeta.rechargeFees = {
  name: 'rechargeFees',
  type: 'select',
  label: 'Frais par def. recharge',
  placeholder: '',
  options:  [
    {
      label: 'Currency A',
      value: 'a'
    },
    {
      label: 'Currency B',
      value: 'b',
    },
    {
      label: 'Currency C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};


PrepaidProgramFormMeta.schema = yup.object().shape(getValidationSchema(PrepaidProgramFormMeta));

export default PrepaidProgramFormMeta;